import { Fetch } from 'lib';
import type { DiscountCodeSortType, DiscountCodeSummary } from 'types';

type RequestResponses = {
  total: number;
  data: DiscountCodeSummary[];
};

type RequestParameters = {
  sortType: DiscountCodeSortType;
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchDiscountCodes = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminDiscountCode/searchDiscountCodes',
    params,
  });

export { searchDiscountCodes };
